import { inject } from "mobx-react";
import React from "react";
import type { Store } from "../../../client/stores";
import * as Webapi from "../generated/webapi.g";
import { CatalogKindTypes, generateCatalogUrl } from "../lib/catalog";
import { isCurrentlyPlayingTrackDetailFragment } from "../lib/guards";
import "./Catalog.style.scss";

export interface CatalogLegacyProps {
    id?: string | number;
    related_id?: string | number;
    description?: string;
    track?: Webapi.CurrentlyPlayingTrackDetailFragment | Webapi.TopTrackDetailFragment;
    kind: CatalogKindTypes;
    store?: Store;
}

export const CatalogLegacy = inject("store")(
    ({ store, track, id, kind, description, related_id }: CatalogLegacyProps) => {
        if (!store) {
            return null;
        }
        const currentTrack = track && isCurrentlyPlayingTrackDetailFragment(track) ? track : track?.track;
        const catalogUrl = generateCatalogUrl(store.env, {
            track: currentTrack,
            id,
            related_id: related_id || "",
            kind,
            embed: true,
        });

        if (catalogUrl) {
            const title = description || "Music Catalog";
            return (
                <div className="component-catalog-container">
                    <iframe src={catalogUrl} title={title} />
                </div>
            );
        }
        return null;
    },
);

export default CatalogLegacy;
